//* Show red alert notification under header
export function showAlert(text) {
    showNotification(text, 'warning');
}

//* Show green confirm notification under header
export function showSuccess(text) {
    showNotification(text, 'confirmation');
}

//* Show blue notification under header (modifier is optional, possible values: notification--confirmation, notification--alert)
export function showNotification(text, modifier) {
    // open the notification
    var notification = document.querySelector("sdx-header")
    if (notification) notification.showToast({
        description: text,
        type: modifier,
    })
}

